import { Component, OnInit, Input, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { License } from '../transactions-list/transactions-list.component';
import { ConfigurationService } from '../../_services/configuration.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-tabs-code-example',
    templateUrl: './tabs-code-example.component.html',
    styleUrls: ['./tabs-code-example.component.scss'],
    standalone: false
})
export class TabsCodeExampleComponent implements OnInit {
  private readonly configurationService: ConfigurationService = inject(ConfigurationService);
  private sanitizer: DomSanitizer = inject(DomSanitizer);


  @Input() data: {licenses: License, paymentID: string};

  htmlWizard = ``;
  htmlJS = ``;
  htmlJSButtonless = ``;
  htmlJSCompact = ``;
  htmlJSinline = ``;
  htmlAndroid = ``;
  htmlIos = ``;
  host: string;
  tabIndex = 2;

  htmlWizardLN: SafeHtml;
  htmlJSLN: SafeHtml;
  htmlJSButtonlessLN: SafeHtml;
  htmlJSCompactLN: SafeHtml;
  htmlJSinlineLN: SafeHtml;
  htmlAndroidLN: SafeHtml;
  htmlIosLN: SafeHtml;

  commentExemple: string;
  commentScript: string;
  commentInitialization: string;
  commentTag: string;
  commentBtnSubmit: string;

  constructor() {
    this.commentExemple = $localize `:@@commentCode-ExempleBtnCheckout: ESEMPIO DI PULSANTE CHECKOUT `;
    this.commentScript = $localize `:@@commentCode-ScriptCdn: LO SCRIPT DA RECUPERARE TRAMITE CDN `;
    this.commentInitialization = $localize `:@@commentCode-Initialization: INIZIALIZZAZIONE CLIENT E UTILIZZO `;
    this.commentTag = $localize `:@@commentCode-Tag: IL TAG DOVE VERRA' VISUALIZZATO L'HOSTED FORM `;
    this.commentBtnSubmit = $localize `:@@commentCode-ExempleBtnSubmit: ESEMPIO DI PULSANTE SUBMIT `;
    this.setHostAndTemplate();
  }

  ngOnInit(): void {
    // Component initialization
  }

addLineNumbers(code: string): SafeHtml {
  const escapeHtml = (unsafe: string) =>
    unsafe.replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');

  const html = code
    .split('\n')
    .map((line, index) =>
      `<span class="line">
         <span class="line-number">${index + 1}</span>
         <span class="line-text">${escapeHtml(line || ' ')}</span>
       </span>`
    )
    .join('\n');

  return this.sanitizer.bypassSecurityTrustHtml(html);
}

copyCode(code: string) {
  const textarea = document.createElement('textarea');
  textarea.value = code;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}



  htmlScripts(integrazione: string){
    const htmlWizard= `
<!DOCTYPE html>
<html>
  <head>
    <title>SDK Redirect Integration Example</title>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
  </head>
  <body>
    <!-- ${this.commentExemple} -->
    <button type="button" onClick="axeptaClient.proceedToPayment('${this.data.paymentID}')">Checkout</button>

    <!-- ${this.commentScript} -->
    <script src="${this.host}/sdk/axepta-pg-redirect.js"></script>

    <!-- ${this.commentInitialization} -->
    <script type="text/javascript">
      let axeptaClient = new AxeptaSDKClient("${this.host}", "${this.data.licenses.wizard}");
    </script>
  </body>
</html>`;

    const htmlJS = `
<!DOCTYPE html>
<html>
  <head>
    <title>SDK JS Integration Example</title>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
  </head>
  <body>
    <!-- ${this.commentExemple} -->
    <button type="button" onClick="axeptaClient.preparePayment('${this.data.paymentID}')">Checkout</button>

    <!-- ${this.commentTag} -->
    <div id="my-axepta-sdk-pg"></div>

    <!-- ${this.commentScript} -->
    <script src="${this.host}/sdk/axepta-pg-sdk.js"></script>

    <!-- ${this.commentInitialization} -->
    <script type="text/javascript">
      let axeptaClient = new AxeptaSDKClient("${this.host}", "${this.data.licenses.js}");
    </script>
  </body>
</html>`;

    const htmlJSButtonless = `
<!DOCTYPE html>
<html>
  <head>
    <title>SDK JS Integration Example</title>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
  </head>
  <body>
    <!-- ${this.commentExemple} -->
    <button type="button" onClick="axeptaClient.preparePayment('${this.data.paymentID}', 'buttonless');">Checkout</button>

    <!-- ${this.commentTag} -->
    <div id="my-axepta-sdk-pg"></div>

    <!-- ${this.commentBtnSubmit} -->
    <button id="submit" type="button" onClick="axeptaClient.submit()">Submit</button>

    <!-- ${this.commentScript} -->
    <script src="${this.host}/sdk/axepta-pg-sdk.js"></script>

    <!-- ${this.commentInitialization} -->
    <script type="text/javascript">
      let axeptaClient = new AxeptaSDKClient("${this.host}", "${this.data.licenses.js}");
    </script>
  </body>
</html>`;


    const htmlJSCompact = `
<!DOCTYPE html>
<html>
  <head>
    <title>SDK JS Integration Example</title>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
  </head>
  <body>
    <!-- ${this.commentExemple} -->
    <button type="button" onClick="axeptaClient.preparePayment('${this.data.paymentID}', 'compact')">Checkout</button>

    <!-- ${this.commentTag} -->
    <div id="my-axepta-sdk-pg"></div>

    <!-- ${this.commentScript} -->
    <script src="${this.host}/sdk/axepta-pg-sdk.js"></script>

    <!-- ${this.commentInitialization} -->
    <script type="text/javascript">
      let axeptaClient = new AxeptaSDKClient("${this.host}", "${this.data.licenses.js}");
    </script>
  </body>
</html>`;

    const htmlJSinline = `
<!DOCTYPE html>
<html>
  <head>
    <title>SDK JS Integration Example</title>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
  </head>
  <body>
    <!-- ${this.commentExemple} -->
    <button type="button" onClick="axeptaClient.preparePayment('${this.data.paymentID}', 'inline');">Checkout</button>

    <!-- ${this.commentTag} -->
    <div id="my-axepta-sdk-pg"></div>

    <!-- ${this.commentBtnSubmit} -->
    <button id="submit" type="button" onClick="axeptaClient.submit()">Submit</button>

    <!-- ${this.commentScript} -->
    <script src="${this.host}/sdk/axepta-pg-sdk.js"></script>

    <!-- ${this.commentInitialization} -->
    <script type="text/javascript">
      let axeptaClient = new AxeptaSDKClient("${this.host}", "${this.data.licenses.js}");
    </script>
  </body>
</html>`;

    const htmlAndroid = `
public class MainActivity extends AppCompatActivity {
  private FragmentPayment.ResultExecutePaymentCallback resultExecutePaymentCallback;
  @Override
  protected void onCreate(Bundle savedInstanceState) {
    super.onCreate(savedInstanceState);
    setContentView(R.layout.activity_main);initCallBackSdkPayment();
    final FragmentPayment fragmentPayment = new FragmentPayment(
      "default",
      "#000000",
      "#FF0000",
      getResources().getDimension(R.dimen.radius_button),
      getResources().getDimension(R.dimen.radius_texts),
      resultExecutePaymentCallback);
    FragmentManager fragmentManager = getSupportFragmentManager();
    FragmentTransaction fragmentTransaction = fragmentManager.beginTransaction();
    fragmentTransaction.add(R.id.container,fragmentPayment).addToBackStack(null).commit();

    fragmentPayment.setEndPointAndLicence("${this.host}","${this.data.licenses.android}");
    fragmentPayment.setPaymentID("${this.data.paymentID}");

    Button customPayButton = findViewById(R.id.custom_pay_button);
    customPayButton.setOnClickListener(new View.OnClickListener() {
      @Override
      public void onClick(View v) {
        fragmentPayment.executeCall();
      }
    });
  }

  private void initCallBackSdkPayment() {
    resultExecutePaymentCallback = new FragmentPayment.ResultExecutePaymentCallback() {
      @Override
      public void onExecuteSuccess() {
        Toast.makeText(getApplicationContext(), "Success", Toast.LENGTH_LONG).show();
      }

      @Override
      public void onExecuteFailure() {
        Toast.makeText(getApplicationContext(), "Failure", Toast.LENGTH_LONG).show();
      }
    };
  }
}`;

    const htmlIos = `
import UIKit
import AxeptaSDKClient

class ViewController: UIViewController, AxeptaSDKClientDelegate
{
  var axepta:AxeptaSDKClient?

  @IBOutletweakvar widget:UIView!;

  overridefunc viewDidLoad()
  {
    super.viewDidLoad()
    self.axepta?.view = widget
    self.axepta = AxeptaSDKClient(backgroundContainerColor:.white,
                                  viewType:"default",
                                  widgetView:widget,
                                  lang:"IT",
                                  backgroundButtonColor:.red,
                                  borderRadiusButton:2,
                                  borderRadiusTextFields:3,
                                  viewController:self,
                                  delegato:self);
    self.axepta?.setPaymentID(payID: "${this.data.paymentID}");
    self.axepta?.setEndPointAndLicense(endPointUrl: "${this.host}",
                                       licenseKey: "${this.data.licenses.ios}");
  }

  //MARK:Delegates
  func onPaymentError(titolo: String?, messaggio: String?)
  {
    print("+++error pay+++")
  }

  func onPaymentFinished()
  {
    print("+++finish pay+++");
  }
}`;


    switch (integrazione) {
      case 'wizard':
        this.htmlWizard = htmlWizard;
        break;

      case 'js':
        this.htmlJS = htmlJS;
        this.htmlJSCompact = htmlJSCompact;
        this.htmlJSinline = htmlJSinline;
        this.htmlJSButtonless = htmlJSButtonless;
        break;

      case 'android':
        this.htmlAndroid = htmlAndroid;
        break;

      case 'ios':
        this.htmlIos = htmlIos;
        break;

      default:
        break;
    }
    this.generateLineNumbers();
  }

  generateLineNumbers() {
    this.htmlWizardLN = this.addLineNumbers(this.htmlWizard);
    this.htmlJSLN = this.addLineNumbers(this.htmlJS);
    this.htmlJSButtonlessLN = this.addLineNumbers(this.htmlJSButtonless);
    this.htmlJSCompactLN = this.addLineNumbers(this.htmlJSCompact);
    this.htmlJSinlineLN = this.addLineNumbers(this.htmlJSinline);
    this.htmlAndroidLN = this.addLineNumbers(this.htmlAndroid);
    this.htmlIosLN = this.addLineNumbers(this.htmlIos);
  }

  createTemplate() {
    if (this.data.licenses.wizard) this.htmlScripts('wizard');
    if (this.data.licenses.js) this.htmlScripts('js');
    if (this.data.licenses.android) this.htmlScripts('android');
    if (this.data.licenses.ios) this.htmlScripts('ios');
  }

  setHostAndTemplate() {
    this.configurationService.getPublicSettings().subscribe((data) => {
      this.host = data?.settings?.host || environment.host;
      this.createTemplate();
    }, () => {
      this.host = environment.host;
      this.createTemplate();
    });
  }

}
